import styles from "./TabsTemplate.module.css";
import React from "react";
import classNames from "classnames";
import { TabTemplate } from "../TabTemplate";
function TabsTemplate({ items, direction, classNameContainer, ...props }) {
    return (React.createElement("div", { className: classNames(styles.container, styles[direction], classNameContainer) }, items.map(item => (React.createElement(TabTemplate, { key: props.getId(item), item: item, ...props })))));
}
export default TabsTemplate;
